const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.88 21.5l-11-20c-.04-.08-.1-.15-.16-.22-.01-.01-.02-.01-.03-.02a.852.852 0 00-.25-.17c-.03-.01-.06-.03-.09-.04-.12-.04-.23-.07-.35-.07s-.23.03-.34.07c-.03.01-.06.02-.08.04-.09.05-.18.1-.26.17-.01.01-.02.01-.02.02-.06.06-.12.14-.17.22l-11 20c-.17.31-.16.69.02.99s.51.49.86.49h22c.35 0 .68-.19.86-.49.17-.3.18-.68.01-.99zM2.69 21L12 4.06 21.31 21z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11 9.98v4c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 17.98,
  r: 1
});

const SvgWarning = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.8d40ff30.svg";
export { ForwardRef as ReactComponent };